import { SlingoCelebrationComponent } from "slingo/components/slingo-celebration-component";

export class PopSlingoCelebrationComponent extends SlingoCelebrationComponent {
}